import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { convertNumberToLocaleMoneyFormat } from '@repo/shared/helpers';
import { useIsMobile } from '@repo/mui-config/hooks';
import { colorPalette } from '@repo/mui-config/color-palette';
export function CustomMarks(_a) {
    var min = _a.min, max = _a.max, currency = _a.currency, isSpecialOfferSelected = _a.isSpecialOfferSelected, isSelectedSpecialOfferPromotionVariant5 = _a.isSelectedSpecialOfferPromotionVariant5;
    var isMobile = useIsMobile();
    var t = useTranslation().t;
    var getColor = function () {
        if (isSelectedSpecialOfferPromotionVariant5) {
            return colorPalette.ink.main;
        }
        else if (isSpecialOfferSelected) {
            return colorPalette.white;
        }
        else {
            return colorPalette.ink.main;
        }
    };
    var color = getColor();
    return (_jsxs(Box, { sx: { display: 'flex', justifyContent: 'space-between' }, children: [_jsx(Box, { children: _jsxs(Typography, { sx: {
                        fontWeight: 'normal',
                        color: color,
                    }, variant: isMobile ? 'subtitle2' : 'textField', children: [t('loanFormPage.advanceAmount.min'), ".", _jsxs(Typography, { component: "span", sx: {
                                marginLeft: '2px',
                                fontWeight: '500',
                                color: color,
                            }, variant: isMobile ? 'subtitle2' : 'textField', children: [convertNumberToLocaleMoneyFormat(min), " ", currency] })] }) }), _jsx(Box, { children: _jsxs(Typography, { sx: {
                        fontWeight: 'normal',
                        color: color,
                    }, variant: isMobile ? 'subtitle2' : 'textField', children: [t('loanFormPage.advanceAmount.max'), ".", _jsxs(Typography, { component: "span", sx: {
                                marginLeft: '2px',
                                fontWeight: '500',
                                color: color,
                            }, variant: isMobile ? 'subtitle2' : 'textField', children: [convertNumberToLocaleMoneyFormat(max), " ", currency] })] }) })] }));
}
